import styled from 'styled-components';

const WrapperSt = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1064px;
`;

export { WrapperSt };
